@if (hasDelay()) {
  <span class="absolute -right-1 -top-1 whitespace-nowrap rounded-full px-1.5 text-[10px] font-bold text-neutrals-white" [class.bg-secondary-red]="isLate()" [class.bg-secondary-green]="!isLate()">{{ displayedDelay() }}</span>
}
